import React from 'react';
import ReactDOM from 'react-dom';
import './app/assets/styles/app.scss';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './app/redux/store';
import MainRoute from './app/routes/MainRoute';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <MainRoute />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
